/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

export const DEFAULT_BOUNDS = {min: 0, max: 255};

export function sameHistogramBounds(bounds1, bounds2) {
  return bounds1.min === bounds2.min && bounds1.max === bounds2.max;
}

export function autoAdjustedBounds(histogram, options = {saturation: undefined, pixelCount: undefined}) {
  const saturation = options.saturation || 0;
  const pixelCount = options.pixelCount || histogram.reduce((acc, n) => acc + n, 0);
  const threshold = Math.trunc(saturation * pixelCount / 200.0);

  let min, max;
  let hsize = histogram.length;

  let i = -1;
  let count = 0;
  let maxIndex = hsize - 1;

  do {
    i++;
    count += histogram[i];
  } while (count <= threshold && i < maxIndex);
  min = i;

  i = hsize;
  count = 0;
  do {
    i--;
    count += histogram[i];
  } while (count <= threshold && i > 0);
  max = i;

  // Min/max are reversed if the histogram is flat.
  return {
    min: Math.min(min, max),
    max: Math.max(min, max)
  };
}

export function emptyHistogram() {
  return new Array(256).fill(0);
}
